import { loadFileAsUint8Array, zstdDecompressString } from "./funcZstd";
import { load as loadYAML } from "js-yaml";
class SkillData {
    constructor(parameter) {
        this.parameter = parameter;
    }
    getId() {
        return this.parameter.id;
    }
    getIdNum() {
        return this.parameter.id_num;
    }
    getName() {
        return this.parameter.name;
    }
    getMaxLv() {
        return this.parameter.max_lv;
    }
    getAttackRange() {
        return this.parameter.attack_range;
    }
    getSpAmount() {
        return this.parameter.sp_amount;
    }
    getSeparateLv() {
        return this.parameter.separate_lv;
    }
    getNeedSkillList() {
        return this.parameter.need_skill_list;
    }
    getMigIdNum() {
        return this.parameter._mig_id_num;
    }
}
export class SkillMap {
    /** 全てのスキルを取得 */
    static getAll() {
        return Object.entries(this.skillMap);
    }
    /** id から Skill を取得 */
    static getById(id) {
        const skillParam = this.skillMap[id];
        return skillParam !== undefined ? new SkillData(skillParam) : undefined;
    }
    /** id から Skill があるか */
    static existsById(id) {
        return this.skillMap[id] !== undefined;
    }
    /** _mig_id_num から Skill を取得 */
    static getByMigIdNum(migIdNum) {
        const skillId = this.migIdNumIndex[migIdNum];
        return skillId !== undefined ? this.getById(skillId) : undefined;
    }
    static getIdByMigIdNum(migIdNum) {
        return this.migIdNumIndex[migIdNum];
    }
    /** スキルデータをロード */
    static async load() {
        const compressed = await loadFileAsUint8Array('../../dist/skill.yaml.zst');
        const skillLines = await zstdDecompressString(compressed) || "";
        try {
            // YAMLとしてロード
            this.skillMap = loadYAML(skillLines);
            // インデックスを構築
            this.migIdNumIndex = {};
            for (const skill of Object.values(this.skillMap)) {
                if (skill._mig_id_num !== null && skill._mig_id_num !== undefined) {
                    this.migIdNumIndex[skill._mig_id_num] = skill.id;
                }
            }
        }
        catch (err) {
            console.error('YAML load error:', err);
        }
    }
    /** ロード完了か確認 **/
    static async isLoaded() {
        return Object.keys(this.skillMap).length > 0;
    }
}
SkillMap.skillMap = {};
SkillMap.migIdNumIndex = {};
window.SkillMap = SkillMap; // グローバルに登録
